import { format, lastDayOfWeek, startOfMonth } from 'date-fns';
import { DATE_FORMAT_US, DATE_FORMAT_US_SHORT } from '../constants/dateFormats';

export function getLastDayOfWeek(date) {
  return lastDayOfWeek(new Date(date), { weekStartsOn: 1 });
}

export function getFirstDayOfMonth(date) {
  return startOfMonth(new Date(date));
}

export function formatDateGraphXAxis(date, showYears) {
  return showYears ? format(date, DATE_FORMAT_US) : format(date, DATE_FORMAT_US_SHORT);
}
